
import RolesViewer from './roles-viewer.vue'
export default {
  components: {RolesViewer},
  props: {
    contacts: {type: Array, required: true}
  },
  emits: ['edit-person']
}
